import { createFileRoute, Outlet } from '@tanstack/react-router'

import { requireOrgScope } from '@/features/auth/require-session'

/**
 * The org app: every screen a dealership's members use, in one org's scope. Come from the
 * platform console, `beforeLoad` moves the operator into an org first (`requireOrgScope`).
 */
export const Route = createFileRoute('/_app/_org')({
  beforeLoad: ({ context }) => requireOrgScope(context.queryClient),
  component: Outlet,
})
